import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import Format from '../../utils/format';
import { Markup } from 'interweave';

@inject(
    'templateStore',
    'shoppingStore',
    'webSettingStore'
)
@observer
class ShoppingDetailModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    modalCloseOnClick = () => {
        this.props.shoppingStore.setShowShoppingDetailModal(false);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const {
            menu,
            shoppingDetail
        } = this.props.shoppingStore;

        const { data: webSettting } = this.props.webSettingStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        {
                                            shoppingDetail === null
                                                ?
                                                null
                                                :
                                                <Row>
                                                    <Col span={24} className='stm-margin-bottom-12 stm-text-align-center'>
                                                        {
                                                            shoppingDetail.imageUrl === ''
                                                                ?
                                                                <img className='stm-width-60-percent' src={menu ? menu.imageUrl : ''} alt={shoppingDetail.taskName} />
                                                                :
                                                                <img className='stm-width-100-percent' src={shoppingDetail.imageUrl} alt={shoppingDetail.taskName} />
                                                        }
                                                        <img className='stm-modal-image-close' src={require('../../assets/image/CloseModal.svg')} alt='closemodal' onClick={this.modalCloseOnClick} />
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-margin-bottom-4 stm-padding-left-16'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                            color: activeTemplate.templateSetting.label.color,
                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                        }}
                                                    >
                                                        {shoppingDetail.taskName}
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-margin-bottom-8 stm-padding-left-16'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                        }}
                                                    >
                                                        {
                                                            shoppingDetail.specialPrice === shoppingDetail.price
                                                                ?
                                                                <span>{webSettting.currencyCode} {Format.Currency(shoppingDetail.price)}</span>
                                                                :
                                                                <>
                                                                    <span>{webSettting.currencyCode} {Format.Currency(shoppingDetail.specialPrice)}</span>
                                                                    <span className='stm-text-decoration-line-through stm-padding-left-4'>{Format.Currency(shoppingDetail.price)}</span>
                                                                </>
                                                        }
                                                    </Col>
                                                    <Col
                                                        span={24}
                                                        className='stm-modal-detail'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                            color: activeTemplate.templateSetting.text.color,
                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Markup content={shoppingDetail.taskDesc} />
                                                    </Col>
                                                </Row>
                                        }
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default ShoppingDetailModal